export default __webpack_public_path__ + "static/media/5 Navigo_400x400.d89fa476.jpg";